import moment from 'moment';
import { types } from '@/app/filters/filters';
import FundInformation from '@/app/modules/fund/components/fund-information/fund-information.vue';
import ConfirmModal from '@/app/modules/toolkit/common/components/confirm-modal/confirm-modal.vue';
import ReviewItem from '@/app/modules/toolkit/common/components/review-item/review-item.vue';
import pdfContainer from '@/app/modules/pdf/containers/pdf-container.vue';

export default {
  name: 'rent-relief-review',
  components: {
    FundInformation,
    ConfirmModal,
    ReviewItem,
    pdfContainer,
  },
  data: () => ({
    loadingComplete: false,
    loadingExit: false,
    showConfirmModal: false,
  }),
  computed: {
    canEdit() {
      const canEditFund = this.$store.getters['fund/canEditActiveFund'] || false;
      const appPermissions = this.$store.getters['account/getAppPermissions'] || [];
      const toolkitAppPermission = appPermissions.filter(
        app => app.appName === 'TOOLKIT',
      )[0];
      return toolkitAppPermission.permission === 'OWNER' && canEditFund;
    },
    isComplete() {
      return this.$store.getters['toolkit/getItem'].status === 'COMPLETE';
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    item() {
      return this.$store.getters['toolkit/getItem'];
    },
    rentRelief() {
      return this.$store.getters['toolkit/getItemData'];
    },
    property() {
      return this.rentRelief.property;
    },
    fullAddress() {
      return `${this.property.address.street} ${this.property.address.suburb} ${this.property.address.state} ${this.property.address.postCode}`;
    },
    tenantName() {
      if (this.property.tenant.type === 'Trust') {
        return `${this.property.tenant.details.trusteeName} as trustee for ${this.property.tenant.details.trustName}`;
      }
      return this.property.tenant.details.companyName;
    },
    drivers() {
      return this.rentRelief.adjustments.drivers.drivers || [];
    },
    otherDriver() {
      return this.rentRelief.adjustments.drivers.other || '';
    },
    adjustments() {
      return this.rentRelief.adjustments.adjustments.adjustments.map((item) => {
        if (item === 'other') {
          return this.rentRelief.adjustments.adjustments.other;
        }
        return item;
      });
    },
    reductions() {
      if (!moment(this.rentRelief.adjustments.deferralDate).isValid()) {
        this.rentRelief.adjustments.deferralDate = null;
      }

      if (!moment(this.rentRelief.adjustments.reduction.startDate).isValid()) {
        this.$rollbar.log('rentRelief.adjustments.reduction.startDate is Invalid',
          this.rentRelief.adjustments.reduction.startDate);
      }

      if (!moment(this.rentRelief.adjustments.reduction.reviewDate).isValid()) {
        this.$rollbar.log('this.rentRelief.adjustments.reduction.reviewDate is Invalid',
          this.rentRelief.adjustments.reduction.reviewDate);
      }

      return {
        amount: this.rentRelief.adjustments.reduction.amount || 0,
        startDate: new Date(this.rentRelief.adjustments.reduction.startDate) || '',
        reviewDate: new Date(
          this.rentRelief.adjustments.reduction.reviewDate,
        ) || '',
        wavier: this.rentRelief.adjustments.waiver || 0,
        deferral: this.rentRelief.adjustments.deferral || 0,
        deferralDate: this.rentRelief.adjustments.deferralDate
          ? new Date(this.rentRelief.adjustments.deferralDate)
          : undefined,
      };
    },
    otherAccommodationsResponse() {
      return this.rentRelief.adjustments.accommodations.hasAccommodations;
    },
    otherAccommodations() {
      if (this.otherAccommodationsResponse) {
        return this.rentRelief.adjustments.accommodations.accommodations.map((item) => {
          if (item === 'Other') {
            return this.rentRelief.adjustments.accommodations.other;
          }
          return item;
        });
      }
      return [];
    },
    landlordResponse() {
      return this.rentRelief.adjustments.landlord.hasLandlord;
    },
    landlord() {
      if (this.landlordResponse) {
        return this.rentRelief.adjustments.landlord.landlord.map((item) => {
          if (item === 'other') {
            return this.rentRelief.adjustments.landlord.other;
          }
          return item;
        });
      }
      return [];
    },
    isEligible() {
      return this.rentRelief.determination.impactedByCovid === 'yes';
    },
  },
  methods: {
    saveItem(complete) {
      return this.$store.dispatch('toolkit/saveItem', complete);
    },
    handleSaveAndNew() {
      this.loadingComplete = true;
      this.showConfirmModal = false;
      this.saveItem(true)
        .then(() => {
          this.$mixpanel.track('Toolkit Item', {
            uuid: this.item.uuid,
            action: 'Completed',
            status: types(this.item.status),
            type: this.item.type,
          });
          if (this.canEdit) {
            this.$router.push('/toolkit/covid/dashboard');
          } else {
            this.$router.push('/');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveAndExit() {
      this.loadingExit = true;
      this.$mixpanel.track('Toolkit Item', {
        uuid: this.item.uuid,
        action: 'Exit',
        status: types(this.item.status),
        type: this.item.type,
      });
      if (this.canEdit) {
        this.$router.push('/toolkit/covid/dashboard');
      } else {
        this.$router.push('/');
      }
    },
  },
};
